import * as React from 'react';
import { connect } from 'react-redux';
import { registerForLocalization, provideLocalizationService } from '@progress/kendo-react-intl';
import { Field } from '@progress/kendo-react-form';
import { ComboBox } from '../../../ui';
import FormDialog from '../../../ui/components/application/form-dialog';
import { toggleAddParticipantDialog, addParticipant, loadAvailableStudents } from '../actions/session-overview-page-actions';

class SessionAddParticipantDialog extends React.PureComponent {

  constructor() {
    super();
    this.handleValidate = this.handleValidate.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleStudentFilter = this.handleStudentFilter.bind(this);
  }

  render() {
    const localizationService = provideLocalizationService(this);
    return (
      <FormDialog
        title={localizationService.toLanguageString('generalCompetencyEventSessionOverview.addParticipantTitle')}
        onSubmit={this.handleSubmit}
        onCancel={this.handleCancel}
        validator={this.handleValidate}
        validationResult={this.props.validationResult}
        confirmButtonText={localizationService.toLanguageString('custom.add')}
        closeButtonText={localizationService.toLanguageString('buttons.cancel')}
        width={400}
        render={() => (
          <Field
            name='student'
            component={ComboBox}
            label={localizationService.toLanguageString('generalCompetencyEventSessionOverview.searchStudent')}
            loading={this.props.availableStudentsLoading}
            data={this.props.availableStudents}
            onFilter={this.handleStudentFilter}
            textField='text'
            valueField='id'
          />
        )}
      />
    );
  }

  handleValidate(values, localizationService) {
    const errors = {};
    if (!values?.student?.id) {
      errors.student = localizationService.toLanguageString('validation.required');
    }
    return errors;
  }

  handleSubmit(values) {
    this.props.addParticipant({
      eventId: this.props.eventId,
      sessionId: this.props.sessionId,
      userId: values.student.id
    });
  }

  handleCancel() {
    this.props.toggleAddParticipantDialog(false);
  }

  handleStudentFilter(e) {
    this.props.loadAvailableStudents({ keyword: e.keyword });
  }
}

registerForLocalization(SessionAddParticipantDialog);

const mapStateToProps = state => ({
  validationResult: state.generalCompetencyEventSessionOverviewPage.addParticipantValidationResult,
  availableStudents: state.generalCompetencyEventSessionOverviewPage.availableStudents,
  availableStudentsLoading: state.generalCompetencyEventSessionOverviewPage.availableStudentsLoading
});

const mapDispatchToProps = dispatch => ({
  toggleAddParticipantDialog: (isVisible) => dispatch(toggleAddParticipantDialog(isVisible)),
  addParticipant: (payload) => dispatch(addParticipant(payload)),
  loadAvailableStudents: (payload) => dispatch(loadAvailableStudents(payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SessionAddParticipantDialog);
